import { moment } from "../date";
import type { Substitution } from "../types";

/**
 * This function is used to derive the display state of a substitution plan
 * based on its underlying plan state and end date.
 * @param substitution
 */
export function getSubstitutionPlanState(substitution: Pick<Substitution, "plan" | "endDate">) {
	const _state = substitution.plan?.state || "pending";

	const isActive = _state === "active";
	const isPending = _state === "pending";
	const isExpired = moment(substitution.endDate).isBefore(moment()) && isPending;

	return { isActive, isPending, isExpired };
}
